import React, { useMemo } from 'react';
import { cn } from '@/lib/utils';
import { 
  Layers, 
  Database, 
  Eye, 
  Printer,
  Menu,
  Code,
  Sparkles,
} from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

interface MobileNavProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  onMenuClick: () => void;
}

const allTabs = [
  { id: 'editor', label: 'Editor', icon: Layers, permission: null },
  { id: 'print', label: 'Print', icon: Printer, permission: 'print_labels' as const },
  { id: 'data', label: 'Data', icon: Database, permission: 'view_data_panel' as const },
  { id: 'preview', label: 'Preview', icon: Eye, permission: 'view_preview' as const },
  { id: 'ai', label: 'AI', icon: Sparkles, permission: 'use_ai_creator' as const },
];

export const MobileNav: React.FC<MobileNavProps> = ({
  activeTab,
  onTabChange,
  onMenuClick,
}) => {
  const { hasPermission } = useAuth();
  const tabs = useMemo(() => allTabs.filter(t => !t.permission || hasPermission(t.permission)), [hasPermission]);
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border safe-area-bottom">
      <div className="flex items-center justify-around h-12 xs:h-14">
        <button
          onClick={onMenuClick}
          className="flex flex-col items-center justify-center gap-0.5 px-2 xs:px-3 py-1.5 xs:py-2 text-muted-foreground touch-target"
        >
          <Menu className="w-4 h-4 xs:w-5 xs:h-5" />
          <span className="text-[9px] xs:text-[10px]">Menu</span>
        </button>
        
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={cn(
                "flex flex-col items-center justify-center gap-0.5 px-2 xs:px-3 py-1.5 xs:py-2 transition-colors touch-target",
                isActive 
                  ? "text-primary" 
                  : "text-muted-foreground"
              )}
            >
              <Icon className="w-4 h-4 xs:w-5 xs:h-5" />
              <span className="text-[9px] xs:text-[10px]">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
